export const serializeResponseForSentry = (res: Response) => {
  const { ok, headers, url, status, statusText } = res;
  return {
    ok,
    status,
    url,
    statusText,
    contentType: headers.get('content-type'),
  };
};
